import { MenuOutlined } from "@ant-design/icons";
import { DndContext } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import {
  Button,
  ConfigProvider,
  Popover,
  Select,
  Table,
  Tooltip,
  Typography,
} from "antd";
import {
  PlusOutlined,
  RiseOutlined,
  FallOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { UpdateRankAPI } from "../../API/UpdateRankAPI";
import React, { useCallback, useEffect, useState } from "react";
import { UpdateRankStatus } from "../../API/UpdateRankStatus";
import { rankingTableColumns } from "../../screens/Rankings/RankingsUtils";
import TableEmptyContent from "../TableEmptyContent/TableEmptyContent";
import { RankingAPI } from "../../API/RankingAPI";
import { useFlightModel } from "../../contexts/FlightModelContext";
const { Text } = Typography;

const DndTable = ({
  listData,
  selectedColumns = [],
  setOpenAddComments,
  setSelectedID,
  setOpenViewComments,
  getRankingDataFun,
  setSpinning,
  setSelectedRow,
  selectedRow,
  dragableState,
  messageToast,
  selectedRowKeysar,
  setSelectedRowKeys,
  assigneeOptions,
  pageSize,
  page,
  totalRecords,
  filteredValues,
  serachInput,
  setPage,
  setPageSize,
  setTotalRecords,
  setRankingData,
}) => {
   const { selectedFlightModel, refreshFlightModels } = useFlightModel();
   console.log("selectedFlightModel",selectedFlightModel);
  const [dataSource, setDataSource] = useState([]);

  const [columns, setColumns] = useState([]);

  const [statusOptions, setStatusOptions] = useState([]);

  useEffect(() => {
    RankingAPI.getStatusOptions()
      .then((res) => {
        if (res?.data) {
          const options = res?.data?.statuses?.map((item) => ({
            value: item.name,
            label: item.name,
          }));
          setStatusOptions([{ value: null, label: "--select--" }, ...options]);
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    let arr = listData?.map((ele, index) => {
      ele.key = `${index + 1}`;
      return ele;
    });
    setDataSource(arr);
  }, [listData]);

  const selectRowFun = useCallback(
    (record) => {
      if (localStorage.getItem("selectedRow") === record.key) {
        localStorage.setItem("selectedRow", "");
        setSelectedRow({});
        setSelectedRowKeys([]);
      } else {
        localStorage.setItem("selectedRow", record.key);
        setSelectedRow({
          id: record?.id,
          key: record.key,
          spec: record?.spec_concat,
          rank: record?.rank,
          repeat_val: record?.repeat_val,
          repeat_max: record?.repeat_max,
          initial_max: record?.initial_max,
          total_labor_cost_max: record?.total_labor_cost_max,
          interval_type: record?.interval_type,
          total_effort_hours: record?.total_effort_hours,
          yield_percentage: record?.yield_percentage,
        });
        setSelectedRowKeys([record.key]);
      }
    },
    [setSelectedRow, setSelectedRowKeys],
  );

  useEffect(() => {
    const sortColumn = selectedColumns
      .sort((a, b) => a.rank - b.rank)
      .map((col) => {
        const columnStyle = rankingTableColumns.find((c) => c.key === col.id);
        return {
          ...columnStyle,
          title: col.label,
          dataIndex: col.id,
          key: col.id,
          onCell: (record) => ({
            onClick: () => {
              selectRowFun(record);
            },
          }),
        };
      });

    setColumns([
      {
        key: "sort",
      },
      ...sortColumn,
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        onCell: (record) => ({
          onClick: () => {
            selectRowFun(record);
          },
        }),
      },
      {
        title: "Comments",
        dataIndex: "comments",
        key: "comments",
        onCell: (record) => ({
          onClick: () => {
            selectRowFun(record);
          },
        }),
      },
      {
        title: "Assigned To",
        dataIndex: "assigned_to",
        key: "assigned_to",
        width: "240px",
        onCell: (record) => ({
          onClick: () => {
            selectRowFun(record);
          },
        }),
      },
    ]);
  }, [selectedColumns, selectRowFun]);

  const onDragEnd = async({ active, over }) => {
    if (dragableState === true) {
      if (over?.id && active.id !== over?.id) {
        const activeInd = dataSource.findIndex((i) => i.key === active.id);
        const overInd = dataSource.findIndex((i) => i.key === over?.id);

        let arr = [];
        if (activeInd > overInd) {
          for (let index = overInd; index < activeInd; index++) {
            const element = dataSource[index]?.spec_concat;
            arr.push(element);
          }
        } else {
          for (let index = activeInd + 1; index <= overInd; index++) {
            const element = dataSource[index]?.spec_concat;
            arr.push(element);
          }
        }

        if (dataSource[activeInd]?.rank !== dataSource[overInd]?.rank) {
            let flightModelToUse = selectedFlightModel;

    // Fallback: fetch from context if not available
    if (!flightModelToUse) {
      const refreshed =await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }
    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");
      setSpinning(false);
      return;
    }
          const bodyData = {
            flight_model:flightModelToUse,
            //  localStorage.getItem("flight_model"),
            
            old_rank: dataSource[activeInd]?.rank,
            new_rank: dataSource[overInd]?.rank,
            spec_list: arr,
            selected_spec: dataSource[activeInd]?.spec_concat,
          };

          setDataSource((previous) => {
            const activeIndex = previous.findIndex((i) => i.key === active.id);
            const overIndex = previous.findIndex((i) => i.key === over?.id);
            return arrayMove(previous, activeIndex, overIndex);
          });

          updateRankFun(bodyData);
        }
      }
    } else {
      messageToast(
        "warning",
        "To change the rank, you must clear all filters applied",
      );
    }
  };

  async function updateRankFun(bodyData) {
    await UpdateRankAPI.dragandupdateRank(bodyData)
      .then((res) => {
        if (res.data?.status === true) {
          setSelectedRowKeys([]);
          setSelectedRow({});
          getRankingDataFun(page, pageSize, false);
          messageToast("success", res.data?.message);
        } else {
          messageToast("error", res.data?.message);
          if (res.data?.reload === true) {
            setTimeout(() => {
              window.location.reload();
            }, "2000");
          }
        }
      })
      .catch((err) => {
        messageToast("error", "Internal Server Error");
      });
  }

  const Row = ({ children, ...props }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      setActivatorNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({
      id: props["data-row-key"],
    });
    const isSelected = selectedRowKeysar.includes(props['data-row-key'])
    const style = {
      ...props.style,
      transform: CSS.Transform.toString(
        transform && {
          ...transform,
          scaleY: 1,
        },
      ),
      transition,
      ...(isDragging
        ? {
            position: "relative",
            zIndex: 9999,
          }
        : {}),
    };
    return (
      <tr {...props} ref={setNodeRef} style={{ ...style }} {...attributes}>
        {React.Children.map(children, (child) => {
          let strDate = "";
          if (child.props?.record?.assigned_on) {
            strDate = new Date(child.props?.record?.assigned_on);
          }

          if (child.key === "sort") {
            return React.cloneElement(child, {
              children: (
                <MenuOutlined
                  ref={setActivatorNodeRef}
                  style={{
                    touchAction: "none",
                    cursor: "move",
                  }}
                  {...listeners}
                />
              ),
            });
          }
          if (child.key === "spec_concat") {
            return React.cloneElement(child, {
              children: (
                <div>
                  <Tooltip title={child.props.record?.task_description}>
                    <span style={{ cursor: "pointer" }}>
                      {child.props.record?.spec_concat}
                    </span>
                  </Tooltip>
                </div>
              ),
            });
          }
          if (child.key === "card_no") {
            return React.cloneElement(child, {
              children: (
                <div>
                  <Popover
                    content={
                      <>
                        <div
                          style={{
                            display: "flex",
                            fontWeight: 500,
                            color: "#565656",
                            fontSize: "15px",
                            lineHeight: "1.5rem",
                          }}
                        >
                          <p style={{ width: "130px" }}>Custom Initial</p>
                          <p>: {child.props.record?.custom_initial}</p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            fontWeight: 500,
                            color: "#565656",
                            fontSize: "15px",
                            lineHeight: "1.5rem",
                          }}
                        >
                          <p style={{ width: "130px" }}>Custom Repeat</p>
                          <p>: {child.props.record?.custom_repeat}</p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            fontWeight: 500,
                            color: "#565656",
                            fontSize: "15px",
                            lineHeight: "1.5rem",
                          }}
                        >
                          <p style={{ width: "130px" }}>MRBR Initial</p>
                          <p>: {child.props.record?.mrbr_initial}</p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            fontWeight: 500,
                            color: "#565656",
                            fontSize: "15px",
                            lineHeight: "1.5rem",
                          }}
                        >
                          <p style={{ width: "130px" }}>MRBR Repeat</p>
                          <p>: {child.props.record?.mrbr_repeat}</p>
                        </div>
                      </>
                    }
                    title={""}
                  >
                    <span style={{ cursor: "pointer", color: isSelected ? 'white' : '#1579ed' }}>
                      {child.props.record?.card_no}
                    </span>
                  </Popover>
                </div>
              ),
            });
          }
          if (child.key === "comments") {
            return React.cloneElement(child, {
              children:
                child.props.record.have_comments === false ? (
                  <ConfigProvider
                    theme={{
                      token: {
                        colorPrimary: "#EBEEF8",
                      },
                    }}
                  >
                    <Button
                      onClick={(e) => {
                        if (e && e.stopPropagation) e.stopPropagation();
                        openCommentFun(child.props.record.id);
                      }}
                      type="primary"
                      style={{ color: "#304CB2" }}
                      icon={<PlusOutlined />}
                    >
                      Add
                    </Button>
                  </ConfigProvider>
                ) : (
                  <ConfigProvider
                    theme={{
                      token: {
                        colorPrimary: "#304CB2",
                      },
                    }}
                  >
                    <Button
                      onClick={(e) => {
                        if (e && e.stopPropagation) e.stopPropagation();
                        viewCommentFun(child.props.record.id);
                      }}
                      type="primary"
                      style={{}}
                      icon={<EyeOutlined />}
                    >
                      View
                    </Button>
                  </ConfigProvider>
                ),
            });
          }
          if (child.key === "status") {
            return React.cloneElement(child, {
              children: (
                <Select
                  defaultValue={child.props.record.status}
                  style={{
                    width: 140,
                    fontSize: "13px",
                  }}
                  value={child.props.record.status}
                  onChange={(e) => statusOnchangeFun(e, child.props.record.id)}
                  options={statusOptions}
                  onClick={(e) => {
                    if (e && e.stopPropagation) e.stopPropagation();
                  }}
                />
              ),
            });
          }
          if (child.key === "wpm_score") {
            return React.cloneElement(child, {
              children: (
                <div>
                  {child.props.record?.is_drag === true ? (
                    <Tooltip title="Manually Moved">
                      <span style={{ color: "red", fontWeight: 500 }}>
                        {child.props.record?.wpm_score.toFixed(3)}
                      </span>
                    </Tooltip>
                  ) : (
                    <span>{child.props.record?.wpm_score.toFixed(3)}</span>
                  )}
                </div>
              ),
            });
          }
          if (child.key === "rank") {
            return React.cloneElement(child, {
              children: (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {child.props.record.rank}
                  {child.props.record.graph_dir === "down" ? (
                    <FallOutlined style={{ marginLeft: "5px", color: "red" }} />
                  ) : child.props.record.graph_dir === "up" ? (
                    <RiseOutlined
                      style={{ marginLeft: "5px", color: "green" }}
                    />
                  ) : (
                    <span
                      style={{
                        display: "inline-block",
                        width: "12px",
                        height: "2px",
                        borderRadius: "2px",
                        backgroundColor: "#526ebf",
                        marginLeft: "5px",
                      }}
                    ></span>
                  )}
                </div>
              ),
            });
          }
          if (child.key === "assigned_to") {
            return React.cloneElement(child, {
              children: (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                  }}
                >
                  {child.props.record.assigned_to ? (
                    <>
                      <Select
                        defaultValue={child.props.record.assigned_to}
                        style={{
                          width: 100,
                          fontSize: "13px",
                          marginRight: "5px",
                        }}
                        value={child.props.record.assigned_to}
                        onChange={(e) =>
                          assignOnchangeFun(e, child.props.record.id)
                        }
                        options={assigneeOptions}
                        onClick={(e) => {
                          if (e && e.stopPropagation) e.stopPropagation();
                        }}
                      />
                      {child.props.record.assigned_to && (
                        <Text
                          style={{
                            fontSize: "12px",
                            textTransform: "capitalize",
                            color:
                              child.props.record.id === selectedRow.id
                                ? "#fff"
                                : "#000",
                          }}
                        >
                          {" "}
                          - on {String(strDate).slice(4, 15)}
                        </Text>
                      )}
                    </>
                  ) : (
                    <Select
                      defaultValue={child.props.record.assigned_to}
                      style={{
                        width: "100%",
                        fontSize: "13px",
                        marginRight: "5px",
                      }}
                      value={child.props.record.assigned_to}
                      onChange={(e) =>
                        assignOnchangeFun(e, child.props.record.id)
                      }
                      options={assigneeOptions}
                      onClick={(e) => {
                        if (e && e.stopPropagation) e.stopPropagation();
                      }}
                    />
                  )}
                </div>
              ),
            });
          }
          return child;
        })}
      </tr>
    );
  };

  async function statusOnchangeFun(e, id) {
       let flightModelToUse = selectedFlightModel;

    // Fallback: fetch from context if not available
    if (!flightModelToUse) {
      const refreshed =await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }
    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }
    if (e !== null) {
      setSpinning(true);
      let arr = [...dataSource];
      arr.map((ele) => {
        if (ele.id === id) {
          ele.status = e;
        }
        return ele;
      });

      const bodyData = {
        id: id,
        status: e,
        flight_model: flightModelToUse,
        // localStorage.getItem("flight_model"),
      };

      await UpdateRankStatus.updateStatus(bodyData)
        .then((res) => {
          if (res.data?.status === true) {
            //setDataSource(arr)
            messageToast("success", res.data?.message);
            getRankingDataFun(page, pageSize, false);
          } else {
            messageToast("error", res.data?.message);
            setSpinning(false);
            if (res.data?.reload === true) {
              setTimeout(() => {
                window.location.reload();
              }, "2000");
            }
          }
        })
        .catch((err) => {
          messageToast("error", "Internal Server Error");
          setSpinning(false);
        });
      // .finally(() => setSpinning(false))
    } else {
      messageToast("warning", "Status cannot be assigned a null value");
    }
  }

  async function assignOnchangeFun(e, id) {
       let flightModelToUse = selectedFlightModel;

    // Fallback: fetch from context if not available
    if (!flightModelToUse) {
      const refreshed =await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }
    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }
    if (e !== "") {
      setSpinning(true);
      let arr = [...dataSource];
      arr.map((ele) => {
        if (ele.id === id) {
          ele.assigned_to = e;
        }
        return ele;
      });

      const bodyData = {
        id: id,
        asg: e,
        flight_model: flightModelToUse
        // localStorage.getItem("flight_model"),
      };

      await UpdateRankStatus.updateAssignee(bodyData)
        .then((res) => {
          if (res.data?.status === true) {
            //setDataSource(arr)
            messageToast("success", res.data?.message);
            getRankingDataFun(page, pageSize, false);
          } else {
            messageToast("error", res.data?.message);
            setSpinning(false);
          }
        })
        .catch((err) => {
          messageToast("error", "Internal Server Error");
          setSpinning(false);
        });
      // .finally(() => setSpinning(false))
    } else {
      messageToast("warning", "The Assignee cannot be assigned a null value");
    }
  }

  function openCommentFun(id) {
    setSelectedID(id);
    setOpenAddComments(true);
  }

  function viewCommentFun(id) {
    setSelectedID(id);
    setOpenViewComments(true);
  }

  const checkHasFilter = () => {
    return (
      filteredValues?.cat?.trim() !== "" ||
      filteredValues?.specType?.trim() !== "" ||
      filteredValues?.status?.length > 0 ||
      filteredValues?.task?.length > 0 ||
      filteredValues?.yieldValueFrom !== 0 ||
      filteredValues?.yieldValueTo !== 100 ||
      filteredValues?.maintenanceCheck?.trim() !== "" ||
      filteredValues?.maintenanceCheckPackage?.trim() !== "" ||
      filteredValues?.maintenanceCheckInterval?.trim() !== "" ||
      filteredValues?.maintenanceCheckPackageInterval?.trim() !== "" ||
      serachInput.trim() !== ""
    );
  };
  //      const handleTableChange = (pagination) => {
  //   const { current, pageSize } = pagination;

  //   getRankingDataFun(current, pageSize);
  // };
  const handleTableChange = async (pagination) => {
    const { current, pageSize } = pagination;

    const hasFilter = checkHasFilter();
       let flightModelToUse = selectedFlightModel;

    // Fallback: fetch from context if not available
    if (!flightModelToUse) {
      const refreshed =await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }
    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }

    if (hasFilter) {
      const queryParams = {
        params: {
          flight_model: flightModelToUse,
          // localStorage.getItem("flight_model"),
          page: current,
          page_size: pageSize,
          spec_type: filteredValues.specType,
          status: filteredValues.status.map((ele) => ele.trim()).join(","),
          mntc_check: filteredValues.maintenanceCheck,
          mntc_check_package: filteredValues.maintenanceCheckPackage,
          mntc_check_interval: filteredValues.maintenanceCheckInterval,
          mntc_check_package_interval:
            filteredValues.maintenanceCheckPackageInterval,
          yield_min: filteredValues.yieldValueFrom,
          yield_max: filteredValues.yieldValueTo,
          fec: filteredValues.cat,
          task_type: filteredValues.task.map((ele) => ele.trim()).join(","),
          search: serachInput.trim(),
        },
      };

      const response = await RankingAPI.getRannkList(queryParams);

      if (response) {
        setRankingData(response?.data?.data || []);
        setTotalRecords(response?.data?.total || 0);
      }
    } else {
      // Normal GET API
      getRankingDataFun(current, pageSize, false);
    }

    setPage(current);
    setPageSize(pageSize);
  };

  return (
    <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
      <SortableContext
        items={dataSource.map((i) => i.key)}
        strategy={verticalListSortingStrategy}
      >
        <Table
          scroll={{ x: "max-content" }}
          components={{
            body: {
              row: Row,
            },
          }}
          locale={{
            emptyText: <TableEmptyContent />,
          }}
          rowSelection={{
            type: "radio",
            selectedRowKeys: selectedRowKeysar,
            onChange: (selectedRowKeys, selectedRows) => {
              localStorage.setItem("selectedRow", selectedRowKeys[0]);
              setSelectedRowKeys(selectedRowKeys);
              setSelectedRow({
                id: selectedRows[0]?.id,
                key: selectedRowKeys,
                spec: selectedRows[0]?.spec_concat,
                rank: selectedRows[0]?.rank,
                repeat_val: selectedRows[0]?.repeat_val,
                repeat_max: selectedRows[0]?.repeat_max,
                initial_max: selectedRows[0]?.initial_max,
                total_labor_cost_max: selectedRows[0]?.total_labor_cost_max,
                interval_type: selectedRows[0]?.interval_type,
                total_effort_hours: selectedRows[0]?.total_effort_hours,
                yield_percentage: selectedRow[0]?.yield_percentage,
              });
            },
          }}
          rowKey="key"
          columns={columns}
          dataSource={dataSource}
          className="antdTable"
          pagination={{
            current: page,
            pageSize: pageSize,
            total: totalRecords,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
          }}
          onChange={handleTableChange}
        />
      </SortableContext>
    </DndContext>
  );
};
export default DndTable;
